/* globals request */
import _ from 'lodash';
import API_URL_MAP from '../configs/url-api';

export function getAdminPassedVideoPolls(filterData) {
  const filter = !_.isEmpty(filterData) ? JSON.stringify(filterData) : '';
  const url = `${API_URL_MAP.PASSED_VIDEO_POLLS}/admin-list`;
  const _url = filter ? `${url}?filter=${filter}` : url;
  return request(_url, {
    method: 'GET',
    auth: 'Bearer',
  });
}

export function getVideoPollList(filterData) {
  const filter = !_.isEmpty(filterData) ? JSON.stringify(filterData) : '';
  const url = API_URL_MAP.VIDEOPOLLS;
  const _url = filter ? `${url}?filter=${filter}` : url;
  return request(_url, {
    method: 'GET',
    auth: 'Bearer',
  });
}

export function getVideoPoll(id) {
  return request(`${API_URL_MAP.VIDEOPOLLS}/${id}`, {
    method: 'GET',
    auth: 'Bearer',
  });
}

export function getPublicVideoPoll(id) {
  return request(`${API_URL_MAP.VIDEOPOLLS}/${id}/public`, {
    method: 'GET',
    auth: 'Bearer',
  });
}

export function removeVideoPoll(id) {
  return request(`${API_URL_MAP.VIDEOPOLLS}/${id}`, {
    method: 'DELETE',
    auth: 'Bearer',
  });
}

export function hideReceivedSentPage(id) {
  return request(`${API_URL_MAP.VIDEOPOLLS}/${id}/hide-received-sent-page`, {
    method: 'POST',
    auth: 'Bearer',
  });
}

export function updateVideoPoll(id, data) {
  return request(`${API_URL_MAP.VIDEOPOLLS}/${id}`, {
    method: 'PATCH',
    auth: 'Bearer',
    body: data,
  });
}

export function createVideoPoll(videoPoll) {
  return request(`${API_URL_MAP.VIDEOPOLLS}`, {
    method: 'POST',
    auth: 'Bearer',
    body: videoPoll,
  });
}

export function addTemplateQuestion(question) {
  return request(`${API_URL_MAP.VIDEOPOLL_TEMPLATES}/question`, {
    method: 'PUT',
    auth: 'Bearer',
    body: {
      question,
    },
  });
}

export function getVideoPollTemplatesData() {
  return request(API_URL_MAP.VIDEOPOLL_TEMPLATES, {
    method: 'GET',
    auth: 'Bearer',
  });
}

export function updateVideoPollTemplate(id, data) {
  return request(`${API_URL_MAP.VIDEOPOLL_TEMPLATES}/${id}`, {
    method: 'PATCH',
    auth: 'Bearer',
    body: data,
  });
}

export function getDefaultVideoPollTemplatesData() {
  return request(API_URL_MAP.DEFAULT_VIDEOPOLL_TEMPLATES, {
    method: 'GET',
    auth: 'Bearer',
  });
}

export function updateDefaultVideoPollTemplate(id, data) {
  return request(`${API_URL_MAP.DEFAULT_VIDEOPOLL_TEMPLATES}/${id}`, {
    method: 'PATCH',
    auth: 'Bearer',
    body: data,
  });
}

export function addDefaultTemplateQuestion(question) {
  return request(`${API_URL_MAP.DEFAULT_VIDEOPOLL_TEMPLATES}/question`, {
    method: 'PUT',
    auth: 'Bearer',
    body: {
      question,
    },
  });
}

export function shareVideoPollViaEmail(videoPollId, emails = []) {
  return request(`${API_URL_MAP.VIDEOPOLLS}/${videoPollId}/share`, {
    method: 'POST',
    auth: 'Bearer',
    body: {
      emails,
    },
  });
}

export function inviteCandidateToVideoPoll(videoPollId, userId) {
  return request(`${API_URL_MAP.VIDEOPOLLS}/${videoPollId}/send/${userId}`, {
    method: 'POST',
    auth: 'Bearer',
  });
}

export function inviteCandidatesToVideoPoll(videoPollId, users) {
  return request(`${API_URL_MAP.VIDEOPOLLS}/${videoPollId}/send-users`, {
    method: 'POST',
    auth: 'Bearer',
    body: {
      users,
    },
  });
}

export function cancelInviteCandidateToVideoPoll(videoPollId, userId) {
  return request(`${API_URL_MAP.VIDEOPOLLS}/${videoPollId}/send/${userId}`, {
    method: 'DELETE',
    auth: 'Bearer',
  });
}

export function updateReceivedUsers(videoPollId, receivedId, data) {
  return request(`${API_URL_MAP.VIDEOPOLLS}/${videoPollId}/received/${receivedId}`, {
    method: 'PATCH',
    auth: 'Bearer',
    body: data,
  });
}

export function addPassedVideoPoll(data) {
  return request(API_URL_MAP.PASSED_VIDEO_POLLS, {
    method: 'POST',
    auth: 'Bearer',
    body: data,
  });
}

export function getPassedVideoPoll(id) {
  return request(`${API_URL_MAP.PASSED_VIDEO_POLLS}/${id}`, {
    method: 'GET',
    auth: 'Bearer',
  });
}

export function removePassedVideoPoll(id) {
  return request(`${API_URL_MAP.PASSED_VIDEO_POLLS}/${id}/remove`, {
    method: 'POST',
    auth: 'Bearer',
    body: {},
  });
}

export function deletePassedVideoPoll(id) {
  return request(`${API_URL_MAP.PASSED_VIDEO_POLLS}/${id}`, {
    method: 'DELETE',
    auth: 'Bearer',
    body: {},
  });
}

export function sendToEmployerPassedVideoPoll(data) {
  return request(API_URL_MAP.PASSED_VIDEO_POLLS + API_URL_MAP.SEND_TO_EMPLOYER, {
    method: 'POST',
    auth: 'Bearer',
    body: data,
  });
}

export function getUnreadCountVideoPollsEmployer() {
  return request(`${API_URL_MAP.VIDEOPOLLS}/unread-employer/count`, {
    method: 'GET',
    auth: 'Bearer',
  });
}

export function removeUnreadVideoPollsEmployer(id, userId) {
  return request(`${API_URL_MAP.VIDEOPOLLS}/unread-employer/remove`, {
    method: 'POST',
    auth: 'Bearer',
    body: {
      videoPoll: id,
      usersIds: [userId],
    },
  });
}

export function getUnreadCountVideoPollsCandidate() {
  return request(`${API_URL_MAP.CANDIDATE_VIDEO_POLLS}/unread-candidate/count`, {
    method: 'GET',
    auth: 'Bearer',
  });
}

export function removeUnreadVideoPollsCandidate(id) {
  return request(`${API_URL_MAP.VIDEOPOLLS}/unread-candidate/remove`, {
    method: 'POST',
    auth: 'Bearer',
    body: {videoPolls: [id]},
  });
}

export function markReadVideoPoll(id) {
  return request(`${API_URL_MAP.CANDIDATE_VIDEO_POLLS}/${id}/mark-read`, {
    method: 'POST',
    auth: 'Bearer',
  });
}

export function getAvailableVideoPollForRecord(id) {
  return request(`${API_URL_MAP.VIDEOPOLLS}/${id}/check-available`, {
    method: 'POST',
    auth: 'Bearer',
    body: undefined,
  });
}

export function addToFavoriteAnswer(videoPollId, data = {}) {
  return request(`${API_URL_MAP.VIDEOPOLLS}/${videoPollId}/favorites`, {
    method: 'PUT',
    auth: 'Bearer',
    body: data,
  });
}

export function removeFromFavoriteAnswer(videoPollId, favoriteId) {
  return request(`${API_URL_MAP.VIDEOPOLLS}/${videoPollId}/favorites/${favoriteId}`, {
    method: 'DELETE',
    auth: 'Bearer',
  });
}

export function removeFromFavoritesByReceivedId(videoPollId, receivedId) {
  return request(`${API_URL_MAP.VIDEOPOLLS}/${videoPollId}/favorites/by-received-id/${receivedId}`, {
    method: 'DELETE',
    auth: 'Bearer',
  });
}

export function hideFromFavoritePage(videoPollId) {
  return request(`${API_URL_MAP.VIDEOPOLLS}/${videoPollId}/hide-favorite-sent-page`, {
    method: 'POST',
    auth: 'Bearer',
  });
}

export function removeVideoPollReceived(videoPollId, receivedId) {
  return request(`${API_URL_MAP.VIDEOPOLLS}/${videoPollId}/received/${receivedId}`, {
    method: 'DELETE',
    auth: 'Bearer',
  });
}

export function removeVideoPollSent(videoPollId, sentId) {
  return request(`${API_URL_MAP.VIDEOPOLLS}/${videoPollId}/sent/${sentId}`, {
    method: 'DELETE',
    auth: 'Bearer',
  });
}

export function getCandidateVideoPollsList(filterData) {
  const filter = !_.isEmpty(filterData) ? JSON.stringify(filterData) : '';
  const url = API_URL_MAP.CANDIDATE_VIDEO_POLLS;
  const _url = filter ? `${url}?filter=${filter}` : url;
  return request(_url, {
    method: 'GET',
    auth: 'Bearer',
  });
}

export function removeCandidateVideoPoll(id) {
  return request(`${API_URL_MAP.CANDIDATE_VIDEO_POLLS}/${id}`, {
    method: 'DELETE',
    auth: 'Bearer',
  });
}

export function removeCandidateVideoPollRecord(pollId, videoPollRecordId) {
  return request(`${API_URL_MAP.CANDIDATE_VIDEO_POLLS}/${pollId}/records/${videoPollRecordId}`, {
    method: 'DELETE',
    auth: 'Bearer',
  });
}

export function getControlPanelVideoPolls(filterData) {
  const filter = !_.isEmpty(filterData) ? JSON.stringify(filterData) : '';
  const url = `${API_URL_MAP.CANDIDATE_VIDEO_POLLS}/admin-list`;
  const _url = filter ? `${url}?filter=${filter}` : url;
  return request(_url, {
    method: 'GET',
    auth: 'Bearer',
  });
}

export function deleteCandidateVideoPoll(pollId) {
  return request(`${API_URL_MAP.CANDIDATE_VIDEO_POLLS}/${pollId}`, {
    method: 'DELETE',
    auth: 'Bearer',
  });
}

export function deleteAllCandidatesVideoPolls(code) {
  return request(`${API_URL_MAP.CANDIDATE_VIDEO_POLLS}/remove-all`, {
    method: 'POST',
    auth: 'Bearer',
    body: {
      code,
    },
  });
}
